$(document).ready(function () {
    // activeFilters();
})

function activeFilters(element) {
    $('.filter').each(function(element) {
        var filtergroup = $(this).find('input:checked').parent().find('span').text();

        var filtertitle = $(this).find('.filter-toggle').text()

        var filtertxt = $(this).find('input:checked').parent().find('span').map(function () {
            return $(this).text();
        }).get().join(', ');

        if(filtergroup != '') {
            $('.filters-active').prepend('<div class="btn btn-default btn-border btn-sm btn-noaction"><strong>'+filtertitle+':</strong> '+filtertxt+'</div>');
        }

    });

    if($('.filters-active').html() != '') {
        $('.product-filters-reset-link').appendTo('.filters-active');
    }
}
